// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FlightSalesActions } from '../duck';
import type { RootState } from '../../index';
import FlightSales from '../components/FlightSales/FlightSales';
import { actions as AlertActions } from '../../alert/duck';

function mapStateToProps(state: RootState) {
  return {
    isFetchingSales: state.flight.isFetchingSales,
    flightSales: state.flight.flightSales,
    fetchSalesError: state.flight.fetchSalesError,
    localeState: state.locale,
    localValues: state.localValues,
    flight: state.flight.flight,
    isFetchingReward: state.flight.isFetchingReward,
    travelerReward: state.flight.travelerReward,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...FlightSalesActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightSales);



// WEBPACK FOOTER //
// ./src/modules/flight/containers/FlightSalesContainer.js